module.exports = __webpack_public_path__ + "img/468126_C1DDB5_8AC460_A1D07C-256px.e9f51147.png";